import React, { Component } from 'react';
import {
    Row,
    Col,
    Input

} from "reactstrap";

import * as Constant from '../../../constants/AppConstants';
import axios from 'axios';

import { loadProgressBar } from 'axios-progress-bar';
loadProgressBar()

class References extends Component {
    constructor(props) {
        super(props)
        // console.log("Comments lead_id" + this.props.id);
        this.getComments = this.props.getComments;
        this.state = {
            lead_id: this.props.id,
            friendReference: this.props.friendReference,
            colleagueReference: this.props.colleagueReference,
            loan_approved: this.props.loan_approved,
            editableFriend: false,
            editableColleague: false,
            citiesFrnd: [],
            citiesColl: [],
            states: [],
            refFriendButtonText: 'EDIT',
            refColleagueButtonText: 'EDIT',
            referenceFriendFields: {

                referenceFriendAddress: '',
                referenceFriendCity: '0',
                referenceFriendEmail: '',
                referenceFriendName: '',
                referenceFriendPhone: '',
                referenceFriendPincode: '',
                referenceFriendState: '0',

            },
            referenceFriendFieldsInitial: {

                referenceFriendAddress: '',
                referenceFriendCity: '0',
                referenceFriendEmail: '',
                referenceFriendName: '',
                referenceFriendPhone: '',
                referenceFriendPincode: '',
                referenceFriendState: '0',

            },
            referenceFriendNameValid: "",
            referenceFriendEmailValid: "",
            referenceFriendAddressValid: "",
            referenceFriendPhoneValid: "",
            referenceFriendCityValid: "",
            referenceFriendPincodeValid: "",
            referenceFriendStateValid: "",

            errors_friend: {
                referenceFriendNameValid: "",
                referenceFriendEmailValid: "",
                referenceFriendAddressValid: "",
                referenceFriendPhoneValid: "",
                referenceFriendCityValid: "",
                referenceFriendPincodeValid: "",
                referenceFriendStateValid: "",
            },
            referenceColleagueFields: {

                referenceColleagueAddress: '',
                referenceColleagueCity: '0',
                referenceColleagueEmail: '',
                referenceColleagueName: '',
                referenceColleaguePhone: '',
                referenceColleaguePincode: '',
                referenceColleagueState: '0',

            },
            referenceColleagueFieldsInitial: {

                referenceColleagueAddress: '',
                referenceColleagueCity: '0',
                referenceColleagueEmail: '',
                referenceColleagueName: '',
                referenceColleaguePhone: '',
                referenceColleaguePincode: '',
                referenceColleagueState: '0',

            },
            referenceColleagueNameValid: "",
            referenceColleagueEmailValid: "",
            referenceColleagueAddressValid: "",
            referenceColleaguePhoneValid: "",
            referenceColleagueCityValid: "",
            referenceColleaguePincodeValid: "",
            referenceColleagueStateValid: "",

            errors_colleague: {
                referenceColleagueNameValid: "",
                referenceColleagueEmailValid: "",
                referenceColleagueAddressValid: "",
                referenceColleaguePhoneValid: "",
                referenceColleagueCityValid: "",
                referenceColleaguePincodeValid: "",
                referenceColleagueStateValid: "",
            }

        }
    }

    componentDidMount() {
        // console.log("componentDidMount");

        this.getStates();
        this.getReferenceDetails();
        // this.getCities();


    }

    getStates() {

        var self = this;

        var querystring = require('querystring');

        var payload = querystring.stringify({
            mode: Constant.GET_REFERENCE_STATES,

        });

        axios({
            method: 'post',
            url: Constant.API_URL,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                auth_token: window.localStorage.getItem(Constant.AUTH_TOKEN),
                token: window.localStorage.getItem(Constant.TOKEN),

            },
            withCredentials: false,
            data: payload,
        })
            .then(function (response) {
                if (response.status == 200) {
                    self.setState(prevState => ({
                        states: response.data,
                    }));
                }

                else if (response.status == 201) {

                    console.log("Error while fetching states : 201")
                }

            }).catch(function (error) {
                // console.log('Error:', error);    
            });
    }

    getFriendCities(state_id) {

        var self = this;

        var querystring = require('querystring');

        var payload = querystring.stringify({
            mode: Constant.GET_REFERENCE_CITIES,
            state_id: state_id
        });

        axios({
            method: 'post',
            url: Constant.API_URL,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                auth_token: window.localStorage.getItem(Constant.AUTH_TOKEN),
                token: window.localStorage.getItem(Constant.TOKEN),

            },
            withCredentials: false,
            data: payload,
        })
            .then(function (response) {
                if (response.status == 200) {
                    self.setState(prevState => ({
                        citiesFrnd: response.data,
                    }));

                }

                else if (response.status == 201) {

                    alert("Error while fetching cities: 201");

                }

                else if (response.status == 404) {

                    alert("Error: Could not fetch cities (404)");

                }

            }).catch(function (error) {
                // console.log('Error:', error);
            });
    }

    getColleagueCities(state_id) {

        var self = this;

        var querystring = require('querystring');

        var payload = querystring.stringify({
            mode: Constant.GET_REFERENCE_CITIES,
            state_id: state_id
        });

        axios({
            method: 'post',
            url: Constant.API_URL,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                auth_token: window.localStorage.getItem(Constant.AUTH_TOKEN),
                token: window.localStorage.getItem(Constant.TOKEN),

            },
            withCredentials: false,
            data: payload,
        })
            .then(function (response) {
                if (response.status == 200) {
                    self.setState(prevState => ({
                        citiesColl: response.data,
                    }));

                }

                else if (response.status == 201) {

                    alert("Error while fetching cities: 201");

                }

                else if (response.status == 404) {

                    alert("Error: Could not fetch cities (404)");

                }

            }).catch(function (error) {
                // console.log('Error:', error);
            });
    }

    handleClickFriend = (e) => {

        e.preventDefault();

        if (this.state.editableFriend === false) {
            this.setState({

                refFriendButtonText: "SAVE",
                editableFriend: true

            });
        }

        else {

            if (this.state.referenceFriendFields["referenceFriendCity"] == 0 ||
                this.state.referenceFriendFields["referenceFriendCity"] == "" ||
                this.state.referenceFriendFields["referenceFriendState"] == 0 ||
                this.state.referenceFriendFields["referenceFriendState"] == "") {
                alert("Enter all reference details(Friend) before submitting");
                return;
            }

            var status_response = this.setReferenceDetails(1);

            status_response.then(data => {
                if (data == 200) {

                    this.setState({

                        refFriendButtonText: "EDIT",
                        editableFriend: false

                    });

                }
            })

        }

    }

    //handle cancellation of change to friend reference details

    handleCancelFriend = () => {

        //change button text to EDIT and revert changes made to previous states

        this.setState(prevState => ({

            refFriendButtonText: "EDIT",

            referenceFriendNameValid: "",
            referenceFriendEmailValid: "",
            referenceFriendAddressValid: "",
            referenceFriendPhoneValid: "",
            referenceFriendCityValid: "",
            referenceFriendPincodeValid: "",
            referenceFriendStateValid: "",

            referenceFriendFields: {

                ...this.state.referenceFriendFieldsInitial
            },
            editableFriend: !this.state.editableFriend,


        }));

    }

    //click on SAVE or EDIT for colleague reference

    handleClickColleague = (e) => {

        e.preventDefault();

        if (this.state.editableColleague === false) {
            this.setState({

                refColleagueButtonText: "SAVE",
                editableColleague: true

            });
        }

        else {

            if (this.state.referenceColleagueFields["referenceColleagueCity"] == 0 ||
                this.state.referenceColleagueFields["referenceColleagueCity"] == "" ||
                this.state.referenceColleagueFields["referenceColleagueState"] == 0 ||
                this.state.referenceColleagueFields["referenceColleagueState"] == "") {
                alert("Enter all reference details(Colleague) before submitting");
                return;
            }
            var status_response = this.setReferenceDetails(2);
            status_response.then(data => {

                if (data == 200) {
                    this.setState({

                        refColleagueButtonText: "EDIT",
                        editableColleague: false

                    });
                }

            })
        }
    }


    //handle cancellation of change to colleague reference details

    handleCancelColleague = () => {

        //change button text to EDIT and revert changes made to previous states

        this.setState({

            refColleagueButtonText: "EDIT",
            referenceColleagueNameValid: "",
            referenceColleagueEmailValid: "",
            referenceColleagueAddressValid: "",
            referenceColleaguePhoneValid: "",
            referenceColleagueCityValid: "",
            referenceColleaguePincodeValid: "",
            referenceColleagueStateValid: "",
            referenceColleagueFields: this.state.referenceColleagueFieldsInitial,
            editableColleague: !this.state.editableColleague,

        });
    }

    //handle changes made in friend reference details
    handleFriendReferencedetailsChange = (field, e) => {

        //Core form validation logic on user input change
        this.setState({
            msg: ""
        });

        switch (field) {
            case 'referenceFriendName':

                //Validate name of reference

                if (e.target.value.length < 2 || e.target.value == "" || e.target.value == null || !e.target.value.match(/^[a-zA-Z ]*['-]*$/) || e.target.value.length > 40) {
                    this.setState({
                        referenceFriendNameValid: 'is-invalid',
                    });

                } else {
                    this.setState({
                        referenceFriendNameValid: "",
                    });
                }
                break;

            case 'referenceFriendEmail':

                //Validate Email ID
                if (e.target.value == "" || !e.target.value.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                    this.setState({
                        referenceFriendEmailValid: 'is-invalid'
                    });
                } else {
                    this.setState({
                        referenceFriendEmailValid: ""
                    });
                }
                break;

            case 'referenceFriendAddress':

                //Validate Address
                if (e.target.value == "" || e.target.value.length < 5 || e.target.value.match(/^[\s]*$/)) {
                    this.setState({
                        referenceFriendAddressValid: 'is-invalid'
                    });
                } else {
                    this.setState({
                        referenceFriendAddressValid: ""
                    });

                }
                break;

            case 'referenceFriendPhone':

                //Validate Number
                if (e.target.value.match(/^\d{10}$/) && (e.target.value[0] == '6' || e.target.value[0] == '7' || e.target.value[0] == '8' || e.target.value[0] == '9')) {
                    this.setState({
                        referenceFriendPhoneValid: ''
                    });
                } else {
                    this.setState({
                        referenceFriendPhoneValid: "is-invalid"
                    });

                }
                break;

            case 'referenceFriendCity':

                if (e.target.value == '0' || e.target.value == '' || e.target.value == 0 || e.target.value == null) {
                    this.setState({
                        referenceFriendCityValid: "is-invalid"
                    }, () => {

                        let temp_err = this.state.errors_friend;
                        temp_err["referenceFriendCityValid"] = this.state.referenceFriendCityValid;
                        this.setState({
                            errors_friend: temp_err
                        });

                    });

                } else {
                    this.setState({
                        referenceFriendCityValid: ""
                    });
                }

                break;

            case 'referenceFriendPincode':

                //Validate Email ID
                if (e.target.value == "" || !e.target.value.match(/^\d{6}$/)) {
                    this.setState({
                        referenceFriendPincodeValid: 'is-invalid'
                    });
                } else {
                    this.setState({
                        referenceFriendPincodeValid: ""
                    });
                }
                break;

            case 'referenceFriendState':
                if (e.target.value == '0' || e.target.value == '' || e.target.value == 0 || e.target.value == null) {
                    this.setState({
                        referenceFriendStateValid: "is-invalid"
                    }, () => {

                        let temp_err = this.state.errors_friend;
                        temp_err["referenceFriendStateValid"] = this.state.referenceFriendStateValid;
                        this.setState({
                            errors_friend: temp_err
                        });
                    });

                } else {
                    this.setState({
                        referenceFriendStateValid: ""
                    });

                    this.getFriendCities(e.target.value);

                }

                break;
            default:
                break;

        }
        //set user value to respecive field
        let temp_referenceFriendFields = this.state.referenceFriendFields;
        temp_referenceFriendFields[field] = e.target.value;

        this.setState(prevState => ({
            referenceFriendFields: temp_referenceFriendFields,
            errors_friend: {

                referenceFriendNameValid: this.state.referenceFriendNameValid,
                referenceFriendEmailValid: this.state.referenceFriendEmailValid,
                referenceFriendAddressValid: this.state.referenceFriendAddressValid,
                referenceFriendPhoneValid: this.state.referenceFriendPhoneValid,
                referenceFriendCityValid: this.state.referenceFriendCityValid,
                referenceFriendPincodeValid: this.state.referenceFriendPincodeValid,
                referenceFriendStateValid: this.state.referenceFriendStateValid

            }
        }));
    }

    handleColleagueReferencedetailsChange = (field, e) => {

        //Core form validation logic on user input change
        this.setState({
            msg: ""
        });


        switch (field) {
            case 'referenceColleagueName':

                //Validate name of reference

                if (e.target.value.length < 2 || e.target.value == "" || e.target.value == null || !e.target.value.match(/^[a-zA-Z ]*['-]*$/) || e.target.value.length > 40) {
                    this.setState({
                        referenceColleagueNameValid: 'is-invalid'
                    });

                } else {
                    this.setState({
                        referenceColleagueNameValid: ""
                    });
                }
                break;

            case 'referenceColleagueEmail':

                //Validate Email ID
                if (e.target.value == "" || !e.target.value.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                    this.setState({
                        referenceColleagueEmailValid: 'is-invalid'
                    });
                } else {
                    this.setState({
                        referenceColleagueEmailValid: ""
                    });
                }
                break;
            case 'referenceColleagueAddress':

                //Validate Address
                if (e.target.value == "" || e.target.value.length < 5 || e.target.value.match(/^[\s]*$/)) {
                    this.setState({
                        referenceColleagueAddressValid: 'is-invalid'
                    });
                } else {
                    this.setState({
                        referenceColleagueAddressValid: ""
                    });
                }

                break;

            case 'referenceColleaguePhone':

                //Validate Number
                if (e.target.value.match(/^\d{10}$/) && (e.target.value[0] == '6' || e.target.value[0] == '7' || e.target.value[0] == '8' || e.target.value[0] == '9')) {
                    this.setState({
                        referenceColleaguePhoneValid: ''
                    });
                } else {
                    this.setState({
                        referenceColleaguePhoneValid: "is-invalid"
                    });

                }

                break;

            case 'referenceColleagueCity':

                if (e.target.value == '0' || e.target.value == '' || e.target.value == 0 || e.target.value == null) {
                    this.setState({
                        referenceColleagueCityValid: "is-invalid"
                    }, () => {

                        let temp_err = this.state.errors_colleague;
                        temp_err["referenceColleagueCityValid"] = this.state.referenceColleagueCityValid;
                        this.setState({
                            errors_colleague: temp_err
                        });
                    });

                } else {
                    this.setState({
                        referenceColleagueCityValid: ""
                    });
                }

                break;

            case 'referenceColleaguePincode':

                //Validate Email ID
                if (e.target.value == "" || !e.target.value.match(/^\d{6}$/)) {
                    this.setState({
                        referenceColleaguePincodeValid: 'is-invalid'
                    });
                } else {
                    this.setState({
                        referenceColleaguePincodeValid: ""
                    });
                }
                break;

            case 'referenceColleagueState':
                if (e.target.value == '0' || e.target.value == '' || e.target.value == 0 || e.target.value == null) {
                    this.setState({
                        referenceColleagueStateValid: "is-invalid"
                    }, () => {

                        let temp_err = this.state.errors_colleague;
                        temp_err["referenceColleagueStateValid"] = this.state.referenceColleagueStateValid;
                        this.setState({
                            errors_colleague: temp_err
                        });

                    });


                } else {
                    this.setState({
                        referenceColleagueStateValid: ""
                    });
                    this.getColleagueCities(e.target.value);

                }

                break;
            default:
                break;

        }

        //set user value to respecive field
        let temp_referenceColleagueFields = this.state.referenceColleagueFields;
        temp_referenceColleagueFields[field] = e.target.value;

        this.setState(prevState => ({
            referenceColleagueFields: temp_referenceColleagueFields,
            errors_colleague: {

                referenceColleagueNameValid:    this.state.referenceColleagueNameValid,
                referenceColleagueEmailValid:   this.state.referenceColleagueEmailValid,
                referenceColleagueAddressValid: this.state.referenceColleagueAddressValid,
                referenceColleaguePhoneValid:   this.state.referenceColleaguePhoneValid,
                referenceColleagueCityValid:    this.state.referenceColleagueCityValid,
                referenceColleaguePincodeValid: this.state.referenceColleaguePincodeValid,
                referenceColleagueStateValid:   this.state.referenceColleagueStateValid

            }
        }));
    }

    getReferenceDetails = () => {

        var self = this;

        var querystring = require('querystring');

        var payload = querystring.stringify({
            mode: Constant.GET_FRIEND_REFERENCE_DETAILS,
            lead_id: self.props.lead_id

        });

        axios({
            method: 'post',
            url: Constant.API_URL,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                auth_token: window.localStorage.getItem(Constant.AUTH_TOKEN),
                token: window.localStorage.getItem(Constant.TOKEN),

            },
            withCredentials: false,
            data: payload,
        })
            .then(function (response) {
                if (response.status == 200) {

                    const friendReferenceDetails_temp = self.state.referenceFriendFields;
                    if (response.data.ref1[0]) {
                        friendReferenceDetails_temp["referenceFriendName"] = response.data.ref1[0].name;
                        friendReferenceDetails_temp["referenceFriendAddress"] = response.data.ref1[0].address;
                        friendReferenceDetails_temp["referenceFriendCity"] = response.data.ref1[0].city_id;
                        friendReferenceDetails_temp["referenceFriendEmail"] = response.data.ref1[0].email;
                        friendReferenceDetails_temp["referenceFriendPhone"] = response.data.ref1[0].mobile;
                        friendReferenceDetails_temp["referenceFriendPincode"] = response.data.ref1[0].pin_code;
                        friendReferenceDetails_temp["referenceFriendState"] = response.data.ref1[0].state_id;
                        const friendReferenceDetails_temp_init = friendReferenceDetails_temp;

                        self.setState(prevState => ({
                            referenceFriendFields: friendReferenceDetails_temp,
                            referenceFriendFieldsInitial: friendReferenceDetails_temp_init
                        })); console.log(self.state.referenceFriendFieldsInitial);


                        self.getFriendCities(response.data.ref1[0].state_id);
                    }

                    if (response.data.ref2[0]) {
                        const colleagueReferenceDetails_temp = self.state.referenceColleagueFields;
                        colleagueReferenceDetails_temp["referenceColleagueName"] = response.data.ref2[0].name;
                        colleagueReferenceDetails_temp["referenceColleagueAddress"] = response.data.ref2[0].address;
                        colleagueReferenceDetails_temp["referenceColleagueCity"] = response.data.ref2[0].city_id;
                        colleagueReferenceDetails_temp["referenceColleagueEmail"] = response.data.ref2[0].email;
                        colleagueReferenceDetails_temp["referenceColleaguePhone"] = response.data.ref2[0].mobile;
                        colleagueReferenceDetails_temp["referenceColleaguePincode"] = response.data.ref2[0].pin_code;
                        colleagueReferenceDetails_temp["referenceColleagueState"] = response.data.ref2[0].state_id;
                        const colleagueReferenceDetails_temp_init = colleagueReferenceDetails_temp;

                        self.setState(prevState => ({
                            referenceColleagueFields: colleagueReferenceDetails_temp,
                            referenceColleagueFieldsInitial: colleagueReferenceDetails_temp_init,
                        }));
                        self.getColleagueCities(response.data.ref2[0].state_id);
                    }
                }

                else if (response.status == 201) {

                    alert("Error while fetching reference details: 201");

                }

            }).catch(function (error) {
                // console.log('Error:', error);
            });

    }

    setReferenceDetails = (id) => {

        var self = this;

        var querystring = require('querystring');

        if (id == 1) {




            var payload = querystring.stringify({
                mode: Constant.SET_REFERENCE_DETAILS,
                lead_id: self.props.lead_id,
                address: self.state.referenceFriendFields["referenceFriendAddress"],
                state_id: self.state.referenceFriendFields["referenceFriendState"],
                city_id: self.state.referenceFriendFields["referenceFriendCity"],
                name: self.state.referenceFriendFields["referenceFriendName"],
                mobile: self.state.referenceFriendFields["referenceFriendPhone"],
                email: self.state.referenceFriendFields["referenceFriendEmail"],
                pincode: self.state.referenceFriendFields["referenceFriendPincode"],
                id: 1
            });
        }

        else if (id == 2) {


            var payload = querystring.stringify({
                mode: Constant.SET_REFERENCE_DETAILS,
                lead_id: self.props.lead_id,
                address: self.state.referenceColleagueFields["referenceColleagueAddress"],
                state_id: self.state.referenceColleagueFields["referenceColleagueState"],
                city_id: self.state.referenceColleagueFields["referenceColleagueCity"],
                name: self.state.referenceColleagueFields["referenceColleagueName"],
                mobile: self.state.referenceColleagueFields["referenceColleaguePhone"],
                email: self.state.referenceColleagueFields["referenceColleagueEmail"],
                pincode: self.state.referenceColleagueFields["referenceColleaguePincode"],
                id: 2
            });

        }

        return axios({
            method: 'post',
            url: Constant.API_URL,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                auth_token: window.localStorage.getItem(Constant.AUTH_TOKEN),
                token: window.localStorage.getItem(Constant.TOKEN),

            },
            withCredentials: false,
            data: payload,
        })
            .then(function (response) {
                if (response.status == 200) {
                    return response.status;

                }

                else if (response.status == 201) {

                    alert("Error : " + response.data.error);


                }

            }).catch(function (error) {
                // console.log('Error:', error);
            });

    }

    render() {
        let loan_status_check = window.localStorage.getItem('loan_status_check');

        const submitRefFriend = this.state.referenceFriendNameValid || this.state.referenceFriendEmailValid || this.state.referenceFriendAddressValid ||
            this.state.referenceFriendPhoneValid || this.state.referenceFriendCityValid || this.state.referenceFriendPincodeValid || this.state.referenceFriendStateValid;

        const submitRefColleague = this.state.referenceColleagueNameValid || this.state.referenceColleagueEmailValid || this.state.referenceColleagueAddressValid ||
            this.state.referenceColleaguePhoneValid || this.state.referenceColleagueCityValid || this.state.referenceColleaguePincodeValid || this.state.referenceColleagueStateValid;

        return (
            <Row className="loanDetails__references">
                <Col xs="12" md="6" lg="6" >

                    <div className="loanDetails__references-friend-header">

                        Reference: Friend

                    </div>
                    <div className="loanDetails__references-friend-header-edit">
                        <button className="loanDetails__references-friend-editBtn" onClick={this.handleClickFriend} disabled={this.state.loan_approved || (submitRefFriend && this.state.refFriendButtonText == "SAVE")}>

                            {this.state.refFriendButtonText}

                        </button>

                        {this.state.editableFriend ?
                            <button onClick={this.handleCancelFriend} className="loanDetails__references-friend-CancelBtn">
                                Cancel
                            </button>
                            :
                            ""

                        }

                    </div>
                    <Row className="loanDetails__references-rows">
                        <Col xs="4" md="4" lg="4" >
                            Name
                        </Col>
                        <Col xs="8" md="8" lg="8" >
                            <input type="text" className="form-control " id="loanDetails__references-friend-name"
                                disabled={!this.state.editableFriend}
                                onChange={this.handleFriendReferencedetailsChange.bind(this, "referenceFriendName")}
                                onKeyUp={this.handleFriendReferencedetailsChange.bind(this, "referenceFriendName")}
                                value={loan_status_check == 'hide' ? "********" : this.state.referenceFriendFields["referenceFriendName"]}>
                            </input>
                            {
                                this.state.referenceFriendNameValid != "" ?
                                    <label style={{ color: "Red", fontSize: "11px" }}>Please enter a valid name
                                    </label>
                                    :
                                    ""
                            }
                        </Col>
                    </Row>
                    <Row className="loanDetails__references-rows">
                        <Col xs="4" md="4" lg="4">
                            Phone No.
                        </Col>
                        <Col xs="8" md="8" lg="8">
                            <input type="number" id="loanDetails__references-friend-phone" className="form-control"
                                disabled={!this.state.editableFriend}
                                onChange={this.handleFriendReferencedetailsChange.bind(this, "referenceFriendPhone")}
                                onKeyUp={this.handleFriendReferencedetailsChange.bind(this, "referenceFriendPhone")}
                                onInput={(e) => {
                                    e.target.value = (e.target.value).toString().slice(0, 10)
                                }}
                                value={loan_status_check == 'hide' ? "********" : this.state.referenceFriendFields["referenceFriendPhone"]}>
                            </input>

                            {
                                this.state.referenceFriendPhoneValid != "" ?
                                    <label style={{ color: "Red", fontSize: "11px" }}>Please enter a valid phone number
                                    </label>
                                    :
                                    ""

                            }

                        </Col>
                    </Row>
                    <Row className="loanDetails__references-rows">
                        <Col xs="4" md="4" lg="4">
                            Email ID
                        </Col>
                        <Col xs="8" md="8" lg="8">
                            <input type="email" id="loanDetails__references-friend-email" className="form-control"
                                disabled={!this.state.editableFriend}
                                onChange={this.handleFriendReferencedetailsChange.bind(this, "referenceFriendEmail")}
                                onKeyUp={this.handleFriendReferencedetailsChange.bind(this, "referenceFriendEmail")}
                                value={loan_status_check == 'hide' ? "********" : this.state.referenceFriendFields["referenceFriendEmail"]}>
                            </input>

                            {
                                this.state.referenceFriendEmailValid != "" ?
                                    <label style={{ color: "Red", fontSize: "11px" }}>Please enter a valid email
                                    </label>
                                    :
                                    ""
                            }

                        </Col>
                    </Row>
                    <Row className="loanDetails__references-rows">
                        <Col xs="4" md="4" lg="4">
                            Address
                        </Col>
                        <Col xs="8" md="8" lg="8">
                            <input type="text" id="loanDetails__references-friend-address" className="form-control"
                                disabled={!this.state.editableFriend}
                                onChange={this.handleFriendReferencedetailsChange.bind(this, "referenceFriendAddress")}
                                onKeyUp={this.handleFriendReferencedetailsChange.bind(this, "referenceFriendAddress")}
                                value={loan_status_check == 'hide' ? "********" : this.state.referenceFriendFields["referenceFriendAddress"]}>

                            </input>
                            {
                                this.state.referenceFriendAddressValid != "" ?
                                    <label style={{ color: "Red", fontSize: "11px" }}>Please enter a valid address
                                    </label>
                                    :
                                    ""
                            }

                        </Col>
                    </Row>
                    <Row className="loanDetails__references-rows">
                        <Col xs="4" md="4" lg="4">
                            Pincode
                        </Col>
                        <Col xs="8" md="8" lg="8">
                            <input type="number" id="loanDetails__references-friend-pincode" className="form-control"
                                disabled={!this.state.editableFriend}
                                onChange={this.handleFriendReferencedetailsChange.bind(this, "referenceFriendPincode")}
                                onKeyUp={this.handleFriendReferencedetailsChange.bind(this, "referenceFriendPincode")}
                                onInput={(e) => {
                                    e.target.value = (e.target.value).toString().slice(0, 6)
                                }}
                                value={loan_status_check == 'hide' ? "********" : this.state.referenceFriendFields["referenceFriendPincode"]}>

                            </input>

                            {
                                this.state.referenceFriendPincodeValid != "" ?
                                    <label style={{ color: "Red", fontSize: "11px" }}>Please enter a valid pincode
                                    </label>
                                    :
                                    ""
                            }

                        </Col>
                    </Row>

                    <Row className="loanDetails__references-rows">
                        <Col xs="4" md="4" lg="4">
                            State
                        </Col>
                        <Col xs="8" md="8" lg="8">
                            <Input type="select" id="loanDetails__references-friend-state" className="form-control"
                                disabled={!this.state.editableFriend}
                                onChange={this.handleFriendReferencedetailsChange.bind(this, "referenceFriendState")}
                                onKeyUp={this.handleFriendReferencedetailsChange.bind(this, "referenceFriendState")}
                                value={loan_status_check == 'hide' ? "********" : this.state.referenceFriendFields["referenceFriendState"]}>
                                <option value="0">Select State</option>

                                {this.state.states.map((data, key) =>
                                    <option key={key} value={data.id}>{data.state_name}</option>
                                )}

                            </Input>
                            {
                                this.state.referenceFriendStateValid != "" ?
                                    <label style={{ color: "Red", fontSize: "11px" }}>Please select a valid state
                                    </label>
                                    :
                                    ""
                            }

                        </Col>
                    </Row>

                    <Row className="loanDetails__references-rows">
                        <Col xs="4" md="4" lg="4">
                            City
                        </Col>
                        <Col xs="8" md="8" lg="8">
                            <Input type="select" id="loanDetails__references-friend-city" className="form-control"
                                name="referenceFriendCity"
                                disabled={!this.state.editableFriend || !this.state.referenceFriendFields["referenceFriendState"]}
                                onChange={this.handleFriendReferencedetailsChange.bind(this, "referenceFriendCity")}
                                onKeyUp={this.handleFriendReferencedetailsChange.bind(this, "referenceFriendCity")}
                                value={loan_status_check == 'hide' ? "********" : this.state.referenceFriendFields["referenceFriendCity"]}
                                style={{fontSize: "0.9em"}}>
                                <option value="0">Select City</option>
                                {this.state.citiesFrnd.map((data, key) =>
                                    <option key={key} value={data.id}>{data.city_name}</option>
                                )}
                            </Input>
                            {
                                this.state.referenceFriendCityValid != "" ?
                                    <label style={{ color: "Red", fontSize: "11px" }}>Please select a valid city
                                    </label>
                                    :
                                    ""
                            }
                        </Col>
                    </Row>
                </Col>

                <Col xs="12" md="6" lg="6" >

                    <div className="loanDetails__references-colleague-header">

                        Reference: Colleague
                    </div>
                    <div className="loanDetails__references-colleague-header-edit">

                        <button className="loanDetails__references-colleague-editBtn" onClick={this.handleClickColleague} disabled={this.state.loan_approved || (submitRefColleague && this.state.refColleagueButtonText == "SAVE")}>

                            {this.state.refColleagueButtonText}

                        </button>

                        {this.state.editableColleague ?
                            <button onClick={this.handleCancelColleague} className="loanDetails__references-colleague-CancelBtn">
                                Cancel
                            </button>
                            :
                            ""
                        }

                    </div>

                    <Row className="loanDetails__references-rows">
                        <Col xs="4" md="4" lg="4" >
                            Name
                        </Col>
                        <Col xs="8" md="8" lg="8" >
                            <input type="text" className="form-control " id="loanDetails__references-colleague-name"
                                disabled={!this.state.editableColleague}
                                onChange={this.handleColleagueReferencedetailsChange.bind(this, "referenceColleagueName")}
                                onKeyUp={this.handleColleagueReferencedetailsChange.bind(this, "referenceColleagueName")}
                                value={loan_status_check == 'hide' ? "********" : this.state.referenceColleagueFields["referenceColleagueName"]}>
                            </input>
                            {
                                this.state.referenceColleagueNameValid != "" ?
                                    <label style={{ color: "Red", fontSize: "11px" }}>Please enter a valid name
                                    </label>
                                    :
                                    ""

                            }
                        </Col>
                    </Row>
                    <Row className="loanDetails__references-rows">
                        <Col xs="4" md="4" lg="4">
                            Phone No.
                        </Col>
                        <Col xs="8" md="8" lg="8">
                            <input type="number" id="loanDetails__references-colleague-phone" className="form-control"
                                disabled={!this.state.editableColleague}
                                onChange={this.handleColleagueReferencedetailsChange.bind(this, "referenceColleaguePhone")}
                                onKeyUp={this.handleColleagueReferencedetailsChange.bind(this, "referenceColleaguePhone")}
                                onInput={(e) => {
                                    e.target.value = (e.target.value).toString().slice(0, 10)
                                }}
                                value={loan_status_check == 'hide' ? "********" : this.state.referenceColleagueFields["referenceColleaguePhone"]}>
                            </input>

                            {
                                this.state.referenceColleaguePhoneValid != "" ?
                                    <label style={{ color: "Red", fontSize: "11px" }}>Please enter a valid phone number
                                    </label>
                                    :
                                    ""

                            }


                        </Col>
                    </Row>
                    <Row className="loanDetails__references-rows">
                        <Col xs="4" md="4" lg="4">
                            Email ID
                        </Col>
                        <Col xs="8" md="8" lg="8">
                            <input type="email" id="loanDetails__references-colleague-email" className="form-control"
                                disabled={!this.state.editableColleague}
                                onChange={this.handleColleagueReferencedetailsChange.bind(this, "referenceColleagueEmail")}
                                onKeyUp={this.handleColleagueReferencedetailsChange.bind(this, "referenceColleagueEmail")}
                                value={loan_status_check == 'hide' ? "********" : this.state.referenceColleagueFields["referenceColleagueEmail"]}>
                            </input>

                            {
                                this.state.referenceColleagueEmailValid != "" ?
                                    <label style={{ color: "Red", fontSize: "11px" }}>Please enter a valid email
                                    </label>
                                    :
                                    ""

                            }


                        </Col>
                    </Row>
                    <Row className="loanDetails__references-rows">
                        <Col xs="4" md="4" lg="4">
                            Address
                        </Col>
                        <Col xs="8" md="8" lg="8">
                            <input type="text" id="loanDetails__references-colleague-address" className="form-control"
                                disabled={!this.state.editableColleague}
                                onChange={this.handleColleagueReferencedetailsChange.bind(this, "referenceColleagueAddress")}
                                onKeyUp={this.handleColleagueReferencedetailsChange.bind(this, "referenceColleagueAddress")}
                                value={loan_status_check == 'hide' ? "********" : this.state.referenceColleagueFields["referenceColleagueAddress"]}>

                            </input>
                            {
                                this.state.referenceColleagueAddressValid != "" ?
                                    <label style={{ color: "Red", fontSize: "11px" }}>Please enter a valid address
                                    </label>
                                    :
                                    ""
                            }

                        </Col>
                    </Row>
                    <Row className="loanDetails__references-rows">
                        <Col xs="4" md="4" lg="4">
                            Pincode
                        </Col>
                        <Col xs="8" md="8" lg="8">
                            <input type="number" id="loanDetails__references-colleague-pincode" className="form-control"
                                disabled={!this.state.editableColleague}
                                onChange={this.handleColleagueReferencedetailsChange.bind(this, "referenceColleaguePincode")}
                                onKeyUp={this.handleColleagueReferencedetailsChange.bind(this, "referenceColleaguePincode")}
                                onInput={(e) => {
                                    e.target.value = (e.target.value).toString().slice(0, 6)
                                }}
                                value={loan_status_check == 'hide' ? "********" : this.state.referenceColleagueFields["referenceColleaguePincode"]}>

                            </input>
                            {
                                this.state.referenceColleaguePincodeValid != "" ?
                                    <label style={{ color: "Red", fontSize: "11px" }}>Please enter a valid pincode
                                    </label>
                                    :
                                    ""
                            }

                        </Col>
                    </Row>
                    <Row className="loanDetails__references-rows">
                        <Col xs="4" md="4" lg="4">
                            State
                        </Col>
                        <Col xs="8" md="8" lg="8">
                            <Input type="select" id="loanDetails__references-colleague-state" className="form-control"
                                disabled={!this.state.editableColleague}
                                onChange={this.handleColleagueReferencedetailsChange.bind(this, "referenceColleagueState")}
                                onKeyUp={this.handleColleagueReferencedetailsChange.bind(this, "referenceColleagueState")}
                                value={loan_status_check == 'hide' ? "********" : this.state.referenceColleagueFields["referenceColleagueState"]}>
                                <option value="0">Select State</option>
                                {this.state.states.map((data, key) =>
                                    <option key={key} value={data.id}>{data.state_name}</option>
                                )}


                            </Input>
                            {
                                this.state.referenceColleagueStateValid != "" ?
                                    <label style={{ color: "Red", fontSize: "11px" }}>Please select a valid state
                                    </label>
                                    :
                                    ""
                            }

                        </Col>
                    </Row>
                    <Row className="loanDetails__references-rows">
                        <Col xs="4" md="4" lg="4">
                            City
                        </Col>
                        <Col xs="8" md="8" lg="8">
                            <Input type="select" id="loanDetails__references-colleague-city" className="form-control"
                                name="referenceColleagueCity"
                                disabled={!this.state.editableColleague || !this.state.referenceColleagueFields["referenceColleagueState"]}
                                onChange={this.handleColleagueReferencedetailsChange.bind(this, "referenceColleagueCity")}
                                onKeyUp={this.handleColleagueReferencedetailsChange.bind(this, "referenceColleagueCity")}
                                value={loan_status_check == 'hide' ? "********" : this.state.referenceColleagueFields["referenceColleagueCity"]}
                                style={{fontSize: "0.9em"}}>
                                <option value="0">Select City</option>
                                {this.state.citiesColl.map((data, key) =>
                                    <option key={key} value={data.id}>{data.city_name}</option>
                                )}
                            </Input>
                            {
                                this.state.referenceColleagueCityValid != "" ?
                                    <label style={{ color: "Red", fontSize: "11px" }}>Please select a valid city
                                    </label>
                                    :
                                    ""
                            }

                        </Col>
                    </Row>

                </Col>
            </Row>
        )
    }
}

export default References;



// WEBPACK FOOTER //
// ./src/views/Pages/LoanApplicationDetails/References.js